import React from 'react';
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField/TextField";
import Typography from "@mui/material/Typography";

const StepNotes = props => {
    const {formik} = props;

    return (
        <>
            <Typography variant='h6' color='primary' fontWeight="normal" sx={{mb: 2}}>
                Note aggiuntive
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField multiline
                               minRows={5}
                               fullWidth
                               name="hostNotes"
                               value={formik.values.hostNotes}
                               onChange={formik.handleChange}
                               error={formik.touched.hostNotes && Boolean(formik.errors.hostNotes)}
                               helperText={formik.touched.hostNotes && formik.errors.hostNotes}/>
                </Grid>
            </Grid>
        </>
    );
};

StepNotes.propTypes = {
    formik: PropTypes.object.isRequired
};

export default StepNotes;